//
// Generated class CoreItem
//

/// <reference path="CoreItem_ManagedObject.ts" />

class CoreItem extends CoreItem_ManagedObject
{

}
